import { create } from "zustand";
import { User, authService } from "../services/auth.service";

function getInitialToken(): string | null {
  if (typeof window === "undefined") return null;
  return authService.getToken();
}

interface AuthState {
  user: User | null;
  token: string | null;
  isAuthenticated: boolean;
  /** user, token, et si true persiste en localStorage (se souvenir de moi), sinon sessionStorage */
  setAuth: (user: User, token: string, rememberMe?: boolean) => void;
  clearAuth: () => void;
  setUser: (user: User) => void;
}

/**
 * Store Zustand pour l'état d'authentification.
 * Token : sessionStorage (session) ou localStorage (se souvenir de moi), géré par auth.service.
 */
export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  token: getInitialToken(),
  isAuthenticated: !!getInitialToken(),
  setAuth: (user, token, rememberMe = true) => {
    authService.setToken(token, rememberMe);
    set({
      user,
      token,
      isAuthenticated: true,
    });
  },
  clearAuth: () => {
    authService.clearStoredToken();
    set({
      user: null,
      token: null,
      isAuthenticated: false,
    });
  },
  setUser: (user) =>
    set({
      user,
    }),
}));
